enum FloorFilter {
	All,
	Current,
}

export default FloorFilter;
